// extracted by mini-css-extract-plugin
export default {"double-toggle":"styles_double-toggle__VfIhy"};